import { motion } from "framer-motion";
import { useModal } from "@/components/essex/ModalContext";

const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/b9pkkc6t_HERO%20VIDEO.mp4";

export default function HeroSection() {
  const { openModal } = useModal();
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/80" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center pt-20">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-xs tracking-[0.25em] uppercase text-[#C2A878] font-sans mb-6"
        >
          Wedding Videographer & Photographer Essex | Based in Wickford, Covering Essex, London, Kent & the South East
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          data-testid="hero-heading"
          className="font-serif text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tighter font-light text-[#F5F5F0] leading-[1.1]"
        >
          Cinematic Wedding Films
          <br />
          <em className="italic text-[#C2A878]">& Photography in Essex</em>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          data-testid="hero-subtitle"
          className="mt-8 text-base md:text-lg text-white/80 font-sans max-w-2xl mx-auto leading-relaxed"
        >
          Wedding Video Essex is an award-winning wedding videographer and photographer based in Wickford, Essex,
          filming over 100 weddings per year across Essex and the South East. Two videographers on every booking.
          Full day coverage. 900+ weddings filmed.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <button
            onClick={openModal}
            data-testid="hero-cta-button"
            className="px-8 py-3.5 bg-[#C2A878] text-[#0A0908] text-sm font-sans font-semibold tracking-wide hover:bg-[#d4bc92] transition-colors duration-300"
          >
            Check Your Date
          </button>
          <a
            href="#films"
            data-testid="hero-films-link"
            className="px-8 py-3.5 border border-white/20 text-[#F5F5F0] text-sm font-sans tracking-wide hover:border-[#C2A878]/40 hover:text-[#C2A878] transition-all duration-300"
          >
            Watch Our Films
          </a>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-5 h-8 border-2 border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2 bg-white/40 rounded-full" />
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0A0908] to-transparent" />
    </section>
  );
}
